module["exports"] = ["gem", "tem", "vijve", "zele"];